const initialState = {
    reconRefId: null,
    sourceRefId: null,
    dashboardType: null,
    uiFieldObject: null,
    query: null,
};

export default initialState;